module.exports = "https://cdn.realtymogul.com/static/media/BOI_hero.63c146c8.jpg";